module.exports = __webpack_public_path__ + "img/mtt_2.3.7992fe57.png";